import { useEffect } from 'react';

const PageTitle = ({ title }) => {
  useEffect(() => {
    document.title = `${title} | RepresenX`;
  }, [title]);

  return null;
};

export default PageTitle;
